module.exports = __webpack_public_path__ + "assets/img/icon1.a9021899.png";